module.exports = __webpack_public_path__ + "img/img_1.618d738.png";